import { itemQuantity } from "../../../api/helpers/shoppingCartHelper.js";
import { mapGetters } from "vuex";
import { logger } from "../../../api/Logger";
import { scrollModify } from "../../../api/helpers/uiHelper";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import { formatMoney } from "accounting";

export default {
  computed: {
    ...mapGetters([
      "cartItems",
      "applicableLoyalityRule",
      "getProductById",
      "getFirstValidRedemptionRule",
      "currencySign",
      "productStatuses",
      "currencySign",
    ]),
    getRollIntoPoints() {
      if (
        this.applicableLoyalityRule.length > 0 &&
        (this.getFirstValidRedemptionRule != null ||
          this.getMenuEntity.PointsToDollarRatio > 0)
      ) {
        if (this.selectedRollIntoModiefiers.length == 0)
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.showRollIntoProduct.FixedPriceValue
          );
        else
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.rollIntoPrice
          );
      } else return null;
    },
    cartQuantity() {
      let item = { id: this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return iq + this.quantity;
    },
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },
    maxQuantity() {
      let item = { id: this.category.ProductID || this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return this.maxItemQuantity - iq;
    },
    sortedModifierGroup() {
      let result = [];
      let that = this;
      this.product.ModifierGroups.forEach((groupId) => {
        result.push({
          groupId: groupId,
          DisplayOrder: that.modifiers[groupId].DisplayOrder,
        });
      });
      result = result.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
      return result.map((m) => m.groupId);
    },
  },
  methods: {
    fixQuantity(group, checked, md, groupID) {
      if (md && group) {
        if (checked) {
          if (group.IsSingleSel) {
            group.Modifiers.forEach(function (item) {
              item.quantity = 0;
              item.IsSelected = false;
              // clear submodifiers
              if (md.ID !== item.ID) item.selectedSubmodifiers = [];
            });
            this.ModifierGroupsStates.filter(
              (p) => p.GroupId == groupID
            ).forEach((state) => {
              state.quantity = 0;
              state.IsSelected = false;
            });
          }
          if (!md.quantity || md.quantity == 0) {
            md.quantity = 1;
            md.IsSelected = true;
          }

          this.$set(md, "parent", groupID);
          this.showSubmodifier(md);
        } else {
          md.quantity = 0;
          md.IsSelected = false;
          // clear submodifiers
          md.selectedSubmodifiers = [];
        }
        let state = this.ModifierGroupsStates.filter(
          (p) => p.GroupId == groupID && p.MID == md.ID
        )[0];
        if (state) {
          state.quantity = md.quantity;
          state.IsSelected = md.IsSelected;
        } else {
          state = {
            GroupId: groupID,
            MID: md.ID,
            quantity: md.quantity,
            IsSelected: md.IsSelected,
            GroupDisplayOrder: group.DisplayOrder,
            ModifierDisplayOrder: md.DisplayOrder,
          };
          this.ModifierGroupsStates.push(state);
        }
      }
      this.$forceUpdate();
    },
    showSubmodifier(md) {
      if (this.hasSubmodifier(md) && this.isSubmodifier == false)
        this.$emit("showSubmodifier", md);
    },
    modifierDisabled(mg, md) {
      return (
        (mg.MaximumDisable && !mg.IsSingleSel && !md.IsSelected) ||
        this.isModifierSoldOut(md)
      );
    },
    decMdQty(md, group, groupID) {
      let state = this.ModifierGroupsStates.filter(
        (p) => p.GroupId == groupID && p.MID == md.ID
      )[0];
      md.quantity = md.quantity || 0;
      if (md.quantity == md.MinQty) md.quantity = 0;
      else md.quantity--;
      if (state) {
        state.quantity = md.quantity;
      } else {
        state = {
          GroupId: groupID,
          MID: md.ID,
          quantity: md.quantity,
          GroupDisplayOrder: group.DisplayOrder,
          ModifierDisplayOrder: md.DisplayOrder,
        };
        this.ModifierGroupsStates.push(state);
      }
      this.$forceUpdate();
    },
    incMdQty(md, group, groupID) {
      let state = this.ModifierGroupsStates.filter(
        (p) => p.GroupId == groupID && p.MID == md.ID
      )[0];
      if (group.IsSingleSel) {
        group.Modifiers.filter((m) => m.ID != md.ID).forEach((m) => {
          m.IsSelected = false;
          m.quantity = 0;
        });
        this.ModifierGroupsStates.filter(
          (p) => p.GroupId == groupID && p.MID != md.ID
        ).forEach((m) => {
          m.IsSelected = false;
          m.quantity = 0;
        });
      }
      md.quantity = md.quantity || 0;
      if (md.quantity == 0 && md.MinQty > 0) {
        md.quantity = md.MinQty;
      } else md.quantity += 1;
      if (state) {
        state.quantity = md.quantity;
      } else {
        state = {
          GroupId: groupID,
          MID: md.ID,
          quantity: md.quantity,
          GroupDisplayOrder: group.DisplayOrder,
          ModifierDisplayOrder: md.DisplayOrder,
        };
        this.ModifierGroupsStates.push(state);
      }
      this.$forceUpdate();
    },
    getModifiers() {
      let selectedModifiers = [];
      this.ModifierGroupsStates.filter((p) => p.quantity > 0).forEach(
        (state) => {
          let that = this;
          selectedModifiers.push({
            ...that.modifiers[state.GroupId].Modifiers.filter(
              (p) => p.ID == state.MID
            )[0],
          });
        }
      );
      return selectedModifiers;
    },
    rollToProduct() {
      if (this.validate()) {
        this.$nextTick(() => {
          scrollModify(true);
        });
        this.$emit("updated", this.getModifiers(), this.rollintoIndex);
      } else {
        this.showValidation();
      }
    },
    cancelModifiers() {
      this.$nextTick(() => {
        scrollModify(true);
      });
      this.$emit("canceled");
    },
    initModifiers() {
      try {
        let intitState = this.initialModifiers;
        this.ModifierGroupsStates.splice(0, this.ModifierGroupsStates.length);
        for (let group of this.product.ModifierGroups) {
          let groupInfo = this.modifiers[group];
          if (groupInfo) {
            if (groupInfo.MinimumSelection > 0) {
              groupInfo.IsForceSel = true;
            }
            if (groupInfo.IsForceSel && !groupInfo.MinimumSelection) {
              groupInfo.MinimumSelection = 1;
            }

            for (let modifier of groupInfo.Modifiers) {
              modifier.MaxQty = modifier.MaxQty || 20;
              modifier.MinQty = groupInfo.IncludeQuantity
                ? modifier.MinQty || 1
                : 1;
              if (modifier.MaxQty < modifier.MinQty)
                modifier.MaxQty = modifier.MinQty;
              let initQuantity = 0;
              let isSelected = false;
              if (intitState) {
                groupInfo.selectionCount = 0;
                let find = intitState.find((md) => md.ID == modifier.ID);
                if (find) {
                  this.ModifierGroupsStates.push({
                    GroupId: group,
                    MID: modifier.ID,
                    quantity: find.quantity,
                    IsSelected: find.IsSelected,
                    GroupDisplayOrder: groupInfo.DisplayOrder,
                    ModifierDisplayOrder: modifier.DisplayOrder,
                  });
                  modifier.quantity = find.quantity;
                  modifier.IsSelected = find.IsSelected;
                  initQuantity = find.quantity;
                  isSelected = find.IsSelected;
                  groupInfo.selectionCount += modifier.quantity;
                }
              }
              Object.defineProperty(modifier, "quantity", {
                enumerable: true,
                writable: true,
                value: initQuantity,
              });
              Object.defineProperty(modifier, "IsSelected", {
                enumerable: true,
                writable: true,
                value: isSelected,
              });
              Object.defineProperty(modifier, "selectedSubmodifiers", {
                enumerable: true,
                writable: true,
                value: [],
              });
            }

            Object.defineProperty(groupInfo, "inValid", {
              enumerable: true,
              writable: true,
              value: false,
            });
          }
        }
      } catch (error) {
        logger.log(error.name, error.message, "", logger.LogType.Error);
      }
    },
    getGroupSpecification(groupID, modifierOption) {
      if (
        !modifierOption ||
        !modifierOption.Modifiers ||
        modifierOption.Modifiers.length == 0
      )
        return "";
      let selectedItemInGroup = 0;
      this.ModifierGroupsStates.filter(
        (p) => p.GroupId == groupID && p.quantity > 0
      ).forEach((state) => {
        selectedItemInGroup += state.quantity;
      });
      let minSelection = modifierOption.MinimumSelection || 0;
      if (minSelection > 0 && modifierOption.IsSingleSel) minSelection = 1;
      if (minSelection == 0 && modifierOption.IsForceSel) minSelection = 1;
      if (minSelection > 0) {
        if (selectedItemInGroup < minSelection) {
          return `Please choose ${minSelection - selectedItemInGroup} item${
            minSelection - selectedItemInGroup > 1 ? "s" : ""
          } from the list below`;
        }
      }
      if (modifierOption.inValid) {
        Object.defineProperty(modifierOption, "inValid", {
          enumerable: true,
          writable: true,
          value: false,
        });
        this.$forceUpdate();
      }
      let maxSelection = modifierOption.MaximumSelection || 0;
      if (maxSelection > 0 && selectedItemInGroup == maxSelection) {
        return `Maximum of ${maxSelection} item${
          maxSelection > 1 ? "s" : ""
        } can be selected`;
      }

      if (selectedItemInGroup > 0) {
        return `${selectedItemInGroup} item${
          selectedItemInGroup > 1 ? "s" : ""
        } selected`;
      }
    },
    checkModifierGroupRules(groupID, modifierOption) {
      if (
        !modifierOption ||
        !modifierOption.Modifiers ||
        modifierOption.Modifiers.length == 0
      )
        return true;
      let selectedItemInGroup = 0;
      this.ModifierGroupsStates.filter(
        (p) => p.GroupId == groupID && p.quantity > 0
      ).forEach((state) => {
        selectedItemInGroup += state.quantity;
      });
      let minSelection = modifierOption.MinimumSelection || 0;
      if (minSelection > 0 && modifierOption.IsSingleSel) minSelection = 1;
      if (minSelection == 0 && modifierOption.IsForceSel) minSelection = 1;
      if (minSelection > 0) {
        if (selectedItemInGroup < minSelection) {
          return false;
        }
      }

      let maxSelection = modifierOption.MaximumSelection || 0;
      if (
        maxSelection &&
        selectedItemInGroup &&
        selectedItemInGroup > maxSelection
      ) {
        return false;
      }

      return true;
    },
    validate(showError = true) {
      let validation = true;
      try {
        for (let group of this.product.ModifierGroups) {
          let groupInfo = this.modifiers[group];
          if (groupInfo) {
            if (!this.checkModifierGroupRules(group, groupInfo)) {
              if (showError) {
                Object.defineProperty(groupInfo, "inValid", {
                  enumerable: true,
                  writable: true,
                  value: true,
                });
              }
              validation = false;
            } else {
              Object.defineProperty(groupInfo, "inValid", {
                enumerable: true,
                writable: true,
                value: false,
              });
            }
          }
        }
        this.$forceUpdate();
      } catch (error) {
        logger.log(error.name, error.message, "", logger.LogType.Error);
      }
      return validation;
    },
    showValidation() {
      setTimeout(() => {
        let el = this.$el.getElementsByClassName("invalid-modifier")[0];
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    },
    checkMaximumSelection() {
      for (let groupID of this.product.ModifierGroups) {
        // if group configure as Auto Select
        let group = this.modifiers[groupID];
        if (group) {
          let selectionCount = 0;
          this.ModifierGroupsStates.filter(
            (p) => p.GroupId == groupID && p.quantity > 0
          ).forEach((state) => {
            selectionCount += state.quantity;
          });
          group.selectionCount = selectionCount;
          if (
            group.MaximumSelection &&
            selectionCount >= group.MaximumSelection &&
            group.MaximumSelection != 0
          ) {
            group.MaximumDisable = true;
          } else {
            group.MaximumDisable = false;
          }
        }
      }
    },
    IsDisableIncreament(md, group) {
      return (
        (md.MaxQty && md.MaxQty <= md.quantity) ||
        (!(group.IsSingleSel && (md.quantity || 0) == 0) &&
          group.MaximumDisable) ||
        (md.quantity == 0 &&
          !group.IsSingleSel &&
          group.selectionCount + md.MinQty > group.MaximumSelection &&
          group.MaximumSelection > 0) ||
        this.isModifierSoldOut(md)
      );
    },
    IsDisableDecreament(md) {
      return md.quantity == 0;
    },
    hasSubmodifier(modifier) {
      if (modifier.LinkedProductID) {
        return this.productHasModifier(
          this.getProductById(modifier.LinkedProductID)
        );
      } else {
        return false;
      }
    },
    computePrice(modifier) {
      let sum = modifier.Price;
      if (modifier.selectedSubmodifiers) {
        modifier.selectedSubmodifiers.forEach((element) => {
          sum += element.Price;
        });
      }
      return sum;
    },
    formatModifierPrice(price) {
      if (price === 0) {
        return "";
      }
      let prefix = "+";
      let money = formatMoney(price, this.currencySign);
      return prefix + money;
    },
    getModifierNameStyle() {
      return [{ width: "80%" }];
    },
    productHasModifier(product) {
      if (
        product &&
        product.ModifierGroups &&
        product.ModifierGroups.length > 0
      ) {
        for (var groupID of product.ModifierGroups);
        {
          let group = this.modifiers[groupID];
          if (group.Modifiers.length > 0) return true;
        }
      }
      return false;
    },
    isModifierSoldOut(modifier) {
      if (modifier.LinkedProductID) {
        const status = this.productStatuses[modifier.LinkedProductID];
        return status === 3;
      }
      return false;
    },
    autoSelectMinimumVariants() {
      const self = this;
      for (let i = 0; i < self.sortedModifierGroup.length; i++) {
        const groupID = self.sortedModifierGroup[i];
        const allModifiers = self.modifiers[groupID].Modifiers;

        if (
          self.modifiers[groupID].AutoSelectMinVariants &&
          !isNaN(parseInt(self.modifiers[groupID].MinimumSelection))
        ) {
          if (self.modifiers[groupID].IncludeQuantity) {
            let checked = 0;
            const maxSelection =
              parseInt(self.modifiers[groupID].MaximumSelection) ||
              parseInt(self.modifiers[groupID].MinimumSelection) + 1;
            const howManyToCheck = parseInt(
              self.modifiers[groupID].MinimumSelection
            );

            for (
              let j = 0;
              checked < howManyToCheck && checked < maxSelection;
              j++
            ) {
              const optionIndex = j % allModifiers.length;
              self.incMdQty(
                allModifiers[optionIndex],
                self.modifiers[groupID],
                groupID
              );
              checked++;
            }
          } else if (self.modifiers[groupID].IsSingleSel) {
            allModifiers[0].IsSelected = true;
            self.fixQuantity(
              self.modifiers[groupID],
              true,
              allModifiers[0],
              groupID
            );
          } else {
            const validOptions = allModifiers.filter((md) => {
              return (
                !(
                  self.modifiers[groupID].MaximumDisable &&
                  !self.modifiers[groupID].IsSingleSel &&
                  !md.IsSelected
                ) && !self.isModifierSoldOut(md)
              );
            });

            let checked = 0;
            const howManyToCheck = Math.min(
              parseInt(self.modifiers[groupID].MinimumSelection),
              validOptions.length
            );

            for (
              let j = 0;
              j < validOptions.length && checked < howManyToCheck;
              j++
            ) {
              validOptions[j].IsSelected = true;
              self.fixQuantity(
                self.modifiers[groupID],
                true,
                validOptions[j],
                groupID
              );
              checked++;
            }
          }
        }
      }
    },
    updateModifiers() {
      this.initModifiers();
      this.$forceUpdate();
      this.$nextTick(() => {
        this.autoSelectMinimumVariants();
        this.$forceUpdate();
      });
    },
  },
};
